// AddVisitor.js - With OTP Verification + React-Select
import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ProductContext } from "../context/AppContext";
import Header from "./Header";
import Swal from "sweetalert2";
import axios from "axios";
import Select from "react-select";
import {
  Button,
  Card,
  Spinner,
  Row,
  Col,
  Form,
  Badge,
  Alert,
} from "react-bootstrap";
import {
  Person,
  Phone,
  Envelope,
  GeoAlt,
  Calendar3,
  Image as ImageIcon,
  FileText,
  Building,
  People,
  Upload,
  ShieldLock,
} from "react-bootstrap-icons";
import Webcam from "react-webcam";
import { FaCamera } from "react-icons/fa";



const StudentAddGatePass = () => {
  const navigate = useNavigate();
  const { StaffData, GetstudentData } = useContext(ProductContext);
  const authtoken = localStorage.getItem("token");
  const webcamRef = useRef(null);
  const cameraInputRef = useRef(null);
  const [showWebcam, setShowWebcam] = useState(false);

  // iOS WebView me getUserMedia (react-webcam) glitch karta hai, isliye wahan native camera kholo
  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

  const openCamera = () => {
    if (isIOS) {
      cameraInputRef.current?.click();
    } else {
      setShowWebcam(true);
    }
  };

  const ParentName =
    GetstudentData?.father_full_name || GetstudentData?.mother_full_name;
  const ParentMobile =
    GetstudentData?.contact_phone || GetstudentData?.contact_phone;
  const ParentEmail =
    GetstudentData?.contact_email || GetstudentData?.mother_full_name;
  const ParentAddress = StaffData?.data?.data?.address || "";

  const [loading, setLoading] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otp, setOtp] = useState("");
  const [uuid, setUuid] = useState("");

  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [staffOptions, setStaffOptions] = useState([]);

  const [VisitorTypeData, setVisitorTypeData] = useState("");
  const [RelationData, setRelationData] = useState("");
  const [previews, setPreviews] = useState({ photo: null, document: null });

  const StudentClass1 = Number(GetstudentData?.select_class);
  const StudentClassSection1 = GetstudentData?.class_section_id;
  const StudentId = GetstudentData?.id;

  const capturePhoto = () => {
    const imageSrc = webcamRef.current.getScreenshot();

    fetch(imageSrc)
      .then((res) => res.blob())
      .then((blob) => {
        const file = new File([blob], "photo.jpg", {
          type: "image/jpeg",
        });

        handleFileChange("photo", file);
      });

    setShowWebcam(false);
  };

  useEffect(() => {
    if (GetstudentData) {
      const StudentClass1 = Number(GetstudentData?.select_class);
      const StudentClassSection1 = GetstudentData?.class_section_id;
      const StudentId = GetstudentData?.id;

      setFormData((prev) => ({
        ...prev,
        class_id: StudentClass1 || "",
        section_id: StudentClassSection1 || "",
        student_id: StudentId || "",
      }));
    }
  }, [GetstudentData]);
  const today = new Date().toISOString().split("T")[0];
  const [formData, setFormData] = useState({
    class_section_id: GetstudentData?.class_section_id,
    student_id: Number(GetstudentData?.id), // keep it integer
    guardian_name: "",
    guardian_mobile_no: "",
    accompanied_by: "",
    reason: "",
    date: "",
    medical_descp: "",
    reg_id: GetstudentData?.regs_id,
  });



  // Fetch Departments
  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const res = await axios.get(
          "https://api.mirai.healthcare/api/masters/department/",
          {
            headers: { "x-auth": authtoken },
          }
        );
        const options = res.data?.data?.map((d) => ({
          label: d.department_name,
          value: d.id,
        }));
        setDepartmentOptions(options);
      } catch (err) {
        console.error("Department fetch failed:", err);
      }
    };
    fetchDepartments();
  }, [authtoken]);

  // Fetch Staff when department changes
  useEffect(() => {
    const fetchStaff = async () => {
      if (!formData.department_id) {
        setStaffOptions([]);
        return;
      }
      try {
        const res = await axios.get(
          `https://api.mirai.healthcare/api/staff-Registration/department/${formData.department_id}`,
          { headers: { "x-auth": authtoken } }
        );
        const options = res.data?.data?.data?.map((s) => ({
          label: s.staff_full_name,
          value: s.id || s.employee_code,
        }));
        setStaffOptions(options);
      } catch (err) {
        console.error("Staff fetch failed:", err);
        setStaffOptions([]);
      }
    };
    fetchStaff();
  }, [formData.department_id, authtoken]);

  const handleDropdownVisitorTypeChange = (item) => {
    setVisitorTypeData(item.value);
    setFormData((prev) => ({
      ...prev,
      visitor_type: item.value,
    }));

    if (item.value === "Student") {
      setFormData((prev) => ({
        ...prev,
        name: GetstudentData?.student_full_name || "",
        mobile_no: GetstudentData?.father_mobile_no || "",
        email: GetstudentData?.father_email || "",
        address: GetstudentData?.contact_address,
      }));
    } else if (item.value === "Parent") {
      setFormData((prev) => ({
        ...prev,
        name: "",
        mobile_no: "",
        email: "",
        address: "",
      }));
    }
  };

  // const handleDropdownRelationDataChange = (item) => {
  //   setRelationData(item.value);
  //   setFormData((prev) => ({
  //     ...prev,
  //     visitor_relation: item.value,
  //   }));

  //   if (item.value === "Father") {
  //     setFormData((prev) => ({
  //       ...prev,
  //       guardian_name: GetstudentData?.father_full_name || "",
  //       mobile_no: GetstudentData?.father_mobile_no || "",
  //       email: GetstudentData?.father_email || "",
  //       address: GetstudentData?.contact_address,
  //     }));
  //   } else if (item.value === "Mother") {
  //     setFormData((prev) => ({
  //       ...prev,
  //       guardian_name: GetstudentData?.mother_full_name || "",
  //       mobile_no: GetstudentData?.mother_mobile_no || "",
  //       email: GetstudentData?.mother_email || "",
  //       address: GetstudentData?.contact_address,
  //     }));
  //   } else {
  //     setFormData((prev) => ({
  //       ...prev,
  //       guardian_name: "",
  //       mobile_no: "",
  //       email: "",
  //       address: "",
  //     }));
  //   }
  // };

  //   const handleDropdownRelationDataChange = (selected) => {
  //   const value = selected.value;

  //   setFormData((prev) => ({
  //     ...prev,
  //     accompanied_by: value,        // <-- correct field
  //   }));

  //   if (value === "Father") {
  //     setFormData((prev) => ({
  //       ...prev,
  //       guardian_name: GetstudentData?.father_full_name || "",
  //       guardian_mobile_no: GetstudentData?.father_mobile_no || "",
  //       email: GetstudentData?.father_email || "",
  //     }));
  //   } else if (value === "Mother") {
  //     setFormData((prev) => ({
  //       ...prev,
  //       guardian_name: GetstudentData?.mother_full_name || "",
  //       guardian_mobile_no: GetstudentData?.mother_mobile_no || "",
  //       email: GetstudentData?.mother_email || "",
  //     }));
  //   }
  // };

  // const handleDropdownRelationDataChange = (selected) => {
  //   const value = selected.value;

  //   let updatedData = {
  //     accompanied_by: value,
  //   };

  //   if (value === "Father") {
  //     updatedData.guardian_name = GetstudentData?.father_full_name || "";
  //     updatedData.guardian_mobile_no = GetstudentData?.father_mobile_no || "";
  //     updatedData.email = GetstudentData?.father_email || "";
  //   } else if (value === "Mother") {
  //     updatedData.guardian_name = GetstudentData?.mother_full_name || "";
  //     updatedData.guardian_mobile_no = GetstudentData?.mother_mobile_no || "";
  //     updatedData.email = GetstudentData?.mother_email || "";
  //   }

  //   setFormData((prev) => ({
  //     ...prev,
  //     ...updatedData,
  //   }));
  // };

  const handleDropdownRelationDataChange = (selected) => {
    const value = selected.value;

    let updatedData = {
      accompanied_by: value,
      guardian_mobile_no: GetstudentData?.contact_phone || "",
      email: GetstudentData?.contact_email || "",
    };

    if (value === "Father") {
      updatedData.guardian_name = GetstudentData?.father_full_name || "";
    }
    else if (value === "Mother") {
      updatedData.guardian_name = GetstudentData?.mother_full_name || "";
    }
    else if (value === "Guardian") {
      // ✅ IMPORTANT: RESET ALL FIELDS
      updatedData.guardian_name = "";
    }

    setFormData((prev) => ({
      ...prev,
      ...updatedData,
    }));
  };

  const VisitorTypeOptions = [
    { label: "Student", value: "Student" },
    { label: "Parent", value: "Parent" },
    { label: "Guardian", value: "Guardian" },
  ];

  const RelationOptions = [
    ...(GetstudentData?.father_full_name
      ? [{ label: "Father", value: "Father" }]
      : []),
    ...(GetstudentData?.mother_full_name
      ? [{ label: "Mother", value: "Mother" }]
      : []),
    ...(GetstudentData?.guardian_name
      ? [{ label: "Guardian", value: "Guardian" }]
      : []),
  ];

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const handleFileChange = (key, file) => {
    if (file) {
      handleChange(key, file);
      setPreviews((prev) => ({
        ...prev,
        [key]: URL.createObjectURL(file),
      }));
    }
  };
  const relationOptions = [];

  if (GetstudentData?.father_full_name) {
    relationOptions.push({ label: "Father", value: "Father" });
  }

  if (GetstudentData?.mother_full_name) {
    relationOptions.push({ label: "Mother", value: "Mother" });
  }
  relationOptions.push({ label: "Guardian", value: "Guardian" });

  const [resendTimer, setResendTimer] = useState(0);

  const sendOtp = async () => {
    let cleanMobile = formData.guardian_mobile_no?.replace(/\D/g, "").slice(-10);

    console.log("Sending OTP to:", cleanMobile);

    if (!cleanMobile || cleanMobile.length !== 10) {
      Swal.fire("Error", "Invalid or missing mobile number", "error");
      return;
    }

    setOtpLoading(true);
    try {
      const res = await axios.post(
        "https://api.mirai.healthcare/api/sms/airtel/send-otp/custom",
        {
          mobile_no: cleanMobile,
          email: formData.email || "",
          name: formData.guardian_name?.split(" ")[0] || "Visitor",
          type: "visitor",
        },
        { headers: { "x-auth": authtoken } }
      );

      const receivedUuid =
        res.data?.message?.data?.uuid || res.data?.data?.uuid;

      if (receivedUuid) {
        setUuid(receivedUuid);
        setOtpSent(true);
        setResendTimer(60);
        Swal.fire({
          icon: "success",
          title: "OTP Sent!",
          text: `OTP sent to ${cleanMobile}`,
        });
      }
    } catch (err) {
      console.log("OTP ERROR:", err.response?.data);
      Swal.fire(
        "Could not send OTP",
        err.response?.data?.message || "OTP sending failed",
        "error"
      );
    } finally {
      setOtpLoading(false);
    }
  };

  // Add timer countdown effect
  useEffect(() => {
    let interval;
    if (resendTimer > 0) {
      interval = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [resendTimer]);

  // Verify OTP - UUID + OTP dono bhejo
  const verifyOtp = async () => {
    if (!otp || otp.length !== 6) {
      Swal.fire("Invalid", "Enter 6-digit OTP", "warning");
      return;
    }
    if (!uuid) {
      Swal.fire("Error", "UUID missing. Please send OTP again.", "error");
      setOtpSent(false);
      return;
    }

    setOtpLoading(true);
    try {
      const res = await axios.post(
        "https://api.mirai.healthcare/api/sms/airtel/verify-otp",
        {
          uuid: uuid, // ← YEH ADD KARNA THA!
          otp: otp,
        },
        {
          headers: {
            "x-auth": authtoken,
            "Content-Type": "application/json",
          },
        }
      );

      if (res.data.success || res.data.message?.success) {
        setOtpVerified(true);
        Swal.fire({
          icon: "success",
          title: "Verified ✓",
          text: "Mobile number verified successfully!",
          timer: 2000,
        });
      }
    } catch (err) {
      console.error(err.response?.data);
      Swal.fire(
        "Invalid OTP",
        err.response?.data?.message || "Wrong OTP",
        "error"
      );
      setOtpVerified(false);
    } finally {
      setOtpLoading(false);
    }
  };
  const DISCLAIMER_TEXT = `I confirm that the concerned Co-ordinator is already aware about it and my
    timetable arrangements are already executed in the substitution chart.`;

  const validateForm = () => {
    const errors = [];

    if (!formData.accompanied_by)
      errors.push("Please select who is accompanying (Father / Mother)");

    if (!formData.guardian_name)
      errors.push("Guardian name is required");

    if (!formData.guardian_mobile_no)
      errors.push("Guardian mobile number is required");

    if (formData.guardian_mobile_no && formData.guardian_mobile_no.length !== 10)
      errors.push("Guardian mobile number must be 10 digits");

    if (!formData.reason)
      errors.push("Please select a reason");

    if (formData.reason === "Medical" && !formData.medical_descp)
      errors.push("Medical description is required");

    if (!formData.date)
      errors.push("Please select a date");

    if (!otpVerified)
      errors.push("Please verify mobile number with OTP");

    // NOTE — Photo is optional → no validation needed

    if (!formData.disclaimer_confirmed)
      errors.push("Please confirm the disclaimer");

    return errors;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = validateForm();
    if (errors.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Missing Required Fields",
        html: errors.join("<br>"),
      });
      return;
    }

    if (!otpVerified) {
      Swal.fire(
        "Verify First",
        "Please verify your mobile number with OTP",
        "warning"
      );
      return;
    }





    const [year, month, day] = formData.date.split("-");
    const formattedDate = `${day}-${month}-${year}`;

    const data = new FormData();
    data.append("class_section_id", GetstudentData?.class_section_id);
    data.append("student_id", JSON.stringify([Number(GetstudentData?.id)]));

    // data.append("student_id", Number(GetstudentData?.id));
    data.append("guardian_name", formData.guardian_name);
    data.append("guardian_mobile_no", formData.guardian_mobile_no);
    data.append("accompanied_by", formData.accompanied_by);
    data.append("date", formData.date);
    data.append("medical_descp", formData.medical_descp);
    data.append("reg_id", GetstudentData?.regs_id);

    if (formData.photo) data.append("visitor_photo", formData.photo);

    try {
      setLoading(true);
      await axios.post("https://api.mirai.healthcare/api/head/student-exit-pass", data, {
        headers: {
          "x-auth": authtoken,
          "Content-Type": "multipart/form-data",
        },
      });

      Swal.fire({
        title: "Success!",
        text: "Visitor pass created successfully",
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
      });
      navigate("/StudentGatePass");
    } catch (err) {
      Swal.fire(
        "Error",
        err.response?.data?.message || "Failed to create gate pass",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  // Cleanup previews
  useEffect(() => {
    return () => {
      if (previews.photo) URL.revokeObjectURL(previews.photo);
      if (previews.document) URL.revokeObjectURL(previews.document);
    };
  }, [previews]);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: "0.75rem",
      padding: "0.25rem",
    }),
  };

  return (
    <div className="page-wrapper min-vh-100 bg-light">
      <Header />

      <div className="content px-4 pt-5">
        {/* Page Header */}
        <div className="text-center mb-4">
          <h2 className="page-title fw-bold mb-0">Create Gate Pass</h2>
          <p className="text-muted">
            Fill in Gate pass details and verify mobile via OTP
          </p>
        </div>

        <Row className="justify-content-center">
          <Col lg={12} xl={12}>
            <Card className="border-0 shadow-sm">
              {/* <Card.Header className="bg-white border-0 py-4">
                <h4 className="mb-0 text-center text-primary">
                  <People className="me-2" size={24} />
                  Gate pass Information
                </h4>
              </Card.Header> */}

              <Card.Body className="p-4 p-md-5">
                <Form onSubmit={handleSubmit}>
                  <Row className="g-4">
                    {/* Personal Info - Disabled */}




                    <div className="col-md-4 mb-1">
                      <label className="form-label" htmlFor="relation">
                        Accompanied By
                      </label>

                      <Select
                        id="relation"
                        classNamePrefix="react-select"
                        value={
                          formData.accompanied_by
                            ? {
                              label: formData.accompanied_by,
                              value: formData.accompanied_by,
                            }
                            : null
                        }
                        // onChange={(selected) =>
                        //   handleDropdownRelationDataChange({
                        //     value: selected.value,
                        //   })
                        // }
                        onChange={(selected) => handleDropdownRelationDataChange(selected)}

                        options={relationOptions}
                        placeholder="Select"
                        isSearchable={false}
                        styles={customStyles}
                      />
                    </div>


                    {["guardian_name", "guardian_mobile_no", "email"].map((field) => (
                      <Col md={4} key={field}>
                        <Form.Group>
                          <Form.Label className="fw-semibold">
                            {field === "guardian_name" && (
                              <Person className="me-2 text-info" size={18} />
                            )}
                            {field === "guardian_mobile_no" && (
                              <Phone className="me-2 text-info" size={18} />
                            )}
                            {field === "email" && (
                              <Envelope className="me-2 text-info" size={18} />
                            )}

                            {field.charAt(0).toUpperCase() +
                              field.slice(1).replace("_", " ")}
                          </Form.Label>
                          <Form.Control
                            type={field === "email" ? "email" : "text"}
                            value={formData[field] || ""}
                            disabled={
                              field === "guardian_mobile_no" || field === "email"
                                ? true
                                : formData.accompanied_by !== "Guardian"
                            }
                            onChange={(e) => handleChange(field, e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                    ))}
                    <Col md={4}>
                      <label className="form-label" htmlFor="reason">
                        Reason
                      </label>

                      <Select
                        id="reason"
                        classNamePrefix="react-select"
                        value={
                          formData.reason
                            ? { label: formData.reason, value: formData.reason }
                            : null
                        }
                        onChange={(selected) =>
                          handleChange("reason", selected.value)
                        }
                        options={[
                          { label: "Medical", value: "Medical" },
                          { label: "Other", value: "Other" },
                        ]}
                        placeholder="Select Reason"
                        isSearchable={false}
                        styles={customStyles}
                      />
                    </Col>

                    {formData.reason === "Medical" && (
                      <Col md={4}>
                        <label className="form-label">Medical Description</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Medical Description"
                          value={formData.medical_descp}
                          onChange={(e) => handleChange("medical_descp", e.target.value)}
                          required
                        />
                      </Col>
                    )}

                    <Col md={4}>
                      <Form.Label className="fw-semibold">
                        <Calendar3 className="me-2 text-info" size={18} />
                        Date <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="date"
                        value={formData.date}
                        onChange={(e) =>
                          handleChange("date", e.target.value)
                        }
                        min={today}
                        required
                      />
                    </Col>




                    {/* OTP Verification Section */}
                    {/* OTP Verification Section */}
                    <Col md={12}>
                      <div className="border rounded-3 p-4 bg-light">
                        <div className="d-flex align-items-center mb-3">
                          <ShieldLock className="text-primary me-2" size={22} />
                          <h5 className="mb-0">
                            Mobile Or Email Verification (Required)
                          </h5>
                          {otpVerified && (
                            <Badge bg="success" className="ms-auto">
                              Verified ✓
                            </Badge>
                          )}
                        </div>

                        {!otpVerified ? (
                          <>
                            {!otpSent ? (
                              <Button
                                variant="outline-primary"
                                onClick={sendOtp}
                                disabled={otpLoading || !formData.guardian_mobile_no}
                              >
                                {otpLoading ? (
                                  <>
                                    <Spinner size="sm" className="me-2" />
                                    Sending OTP...
                                  </>
                                ) : (
                                  "Send OTP"
                                )}
                              </Button>
                            ) : (
                              <Row className="align-items-center">
                                <Col md={6}>
                                  <Form.Control
                                    type="text"
                                    placeholder="Enter 6-digit OTP"
                                    value={otp}
                                    onChange={(e) =>
                                      setOtp(
                                        e.target.value
                                          .replace(/\D/g, "")
                                          .slice(0, 6)
                                      )
                                    }
                                    maxLength={6}
                                  />
                                </Col>
                                <Col md={6}>
                                  <div className="d-flex gap-2">
                                    <Button
                                      variant="success"
                                      onClick={verifyOtp}
                                      disabled={otpLoading || otp.length !== 6}
                                      className="flex-fill"
                                    >
                                      {otpLoading
                                        ? "Verifying..."
                                        : "Verify OTP"}
                                    </Button>
                                    <Button
                                      variant="outline-secondary"
                                      onClick={sendOtp}
                                      disabled={otpLoading || resendTimer > 0}
                                    >
                                      {otpLoading ? (
                                        <Spinner size="sm" />
                                      ) : resendTimer > 0 ? (
                                        `Resend in ${resendTimer}s`
                                      ) : (
                                        "Resend"
                                      )}
                                    </Button>
                                  </div>
                                </Col>
                              </Row>
                            )}
                            {otpSent && !otpVerified && (
                              <small className="text-muted d-block mt-2">
                                OTP sent to {formData.guardian_mobile_no} or{" "}
                                {formData.email}
                              </small>
                            )}
                          </>
                        ) : (
                          <Alert variant="success" className="mb-0">
                            <ShieldLock className="me-2" />
                            OTP verified successfully!
                          </Alert>
                        )}
                      </div>
                    </Col>



                    <Col md={12}>
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={formData.disclaimer_confirmed}
                          onChange={(e) =>
                            handleChange(
                              "disclaimer_confirmed",
                              e.target.checked ? 1 : 0
                            )
                          }
                        />
                        I confirm that the concerned Co-ordinator is already
                        aware about it and my timetable arrangements are already
                        executed in the substitution chart.
                      </label>

                    </Col>


                    {/* Photo & Document Uploads */}
                    {/* <Col md={6}>
                      <Form.Label className="fw-semibold">
                        <ImageIcon className="me-2 text-info" size={18} />
                        Visitor Photo (Optional)
                      </Form.Label>
                      <div className="border rounded-3 p-3 text-center bg-light">
                        {previews.photo ? (
                          <img
                            src={previews.photo}
                            alt="Preview"
                            className="img-fluid rounded mb-3"
                            style={{ maxHeight: "180px" }}
                          />
                        ) : (
                          <div
                            className="bg-secondary bg-opacity-10 rounded-3 d-flex align-items-center justify-content-center mb-3"
                            style={{ height: "180px" }}
                          >
                            <ImageIcon size={48} className="text-muted" />
                          </div>
                        )}
                        <Form.Control
                          type="file"
                          accept="image/*"
                          onChange={(e) =>
                            handleFileChange("photo", e.target.files[0])
                          }
                        />
                        <small className="text-muted">Max 4MB • JPG, PNG</small>
                      </div>
                    </Col> */}
                    <Col md={6}>
                      <Form.Label className="fw-semibold">
                        <ImageIcon className="me-2 text-info" size={18} />
                        Photo (Optional)
                      </Form.Label>

                      <div className="border rounded-3 p-3 text-center bg-light">

                        {/* Preview */}
                        {previews.photo ? (
                          <img
                            src={previews.photo}
                            alt="Preview"
                            className="img-fluid rounded mb-3"
                            style={{ maxHeight: "180px" }}
                          />
                        ) : (
                          <div
                            className="bg-secondary bg-opacity-10 rounded-3 d-flex align-items-center justify-content-center mb-3"
                            style={{ height: "180px" }}
                          >
                            <ImageIcon size={48} className="text-muted" />
                          </div>
                        )}

                        {/* File + Camera Buttons */}
                        <div className="d-flex gap-2">
                          <Form.Control
                            type="file"
                            accept="image/*"
                            onChange={(e) =>
                              handleFileChange("photo", e.target.files[0])
                            }
                          />

                          <Button onClick={openCamera}>
                            <FaCamera />
                          </Button>

                          <input
                            ref={cameraInputRef}
                            type="file"
                            accept="image/*"
                            capture="environment"
                            hidden
                            onChange={(e) => {
                              handleFileChange("photo", e.target.files[0]);
                              e.target.value = "";
                            }}
                          />
                        </div>

                        <small className="text-muted">Max 4MB • JPG, PNG</small>

                        {/* Webcam */}
                        {showWebcam && (
                          <div className="mt-3">
                            <Webcam
                              ref={webcamRef}
                              screenshotFormat="image/jpeg"
                              width={250}
                            />

                            <div className="mt-2">
                              <Button variant="success" onClick={capturePhoto}>
                                Capture
                              </Button>

                              <Button
                                variant="danger"
                                className="ms-2"
                                onClick={() => setShowWebcam(false)}
                              >
                                Cancel
                              </Button>
                            </div>
                          </div>
                        )}
                      </div>
                    </Col>


                  </Row>

                  <div className="text-center mt-5">
                    <Button
                      type="submit"
                      size="lg"
                      variant={otpVerified ? "primary" : "secondary"}
                      className="px-5"
                      disabled={loading || !otpVerified}
                    >
                      {loading ? (
                        <>
                          <Spinner size="sm" className="me-2" />
                          Creating Pass...
                        </>
                      ) : (
                        <>
                          <Upload className="me-2" size={20} />
                          Create Gate Pass
                        </>
                      )}
                    </Button>
                    {!otpVerified && (
                      <p className="text-muted mt-3 mb-0">
                        Please verify mobile number with OTP to enable
                        submission
                      </p>
                    )}
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      <style jsx>{`
        .form-control:disabled {
          background-color: #f8f9fa;
          opacity: 0.8;
        }
        .card {
          border-radius: 1rem;
        }
        .card-header {
          border-radius: 1rem 1rem 0 0 !important;
        }
        .form-control,
        .form-select {
          border-radius: 0.75rem;
          padding: 0.75rem 1rem;
        }
      `}</style>
    </div>
  );
};

export default StudentAddGatePass;
